import * as React from "react";

import { Animated, StyleSheet, Text, View } from "react-native";
import { Colors, Metrics } from "../resources";

import { SIcon } from "../components/atoms";
import { SIconType } from "../types";
import { useRef } from "react";

const Loading = () => {
  const opacity = useRef<Animated.Value>(new Animated.Value(1)).current;

  return (
    <Animated.View style={[styles.container, { opacity: opacity }]}>
      <View style={styles.edge} />
      <View style={styles.row}>
        <SIcon type={SIconType.Logo} size={Metrics.screenWidth / 10} />
      </View>
      <View style={styles.edge} />
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Colors.white,
  },
  row: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  edge: {
    flex: 1,
  },
});

export default Loading;
